import { render, staticRenderFns } from "./PDFPreviewDialog.vue?vue&type=template&id=37d6e83e&scoped=true&"
import script from "./PDFPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./PDFPreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d6e83e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d6e83e')) {
      api.createRecord('37d6e83e', component.options)
    } else {
      api.reload('37d6e83e', component.options)
    }
    module.hot.accept("./PDFPreviewDialog.vue?vue&type=template&id=37d6e83e&scoped=true&", function () {
      api.rerender('37d6e83e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/PDFPreviewDialog.vue"
export default component.exports